import styled from 'styled-components';

export const Wrapper = styled('div')`
  display: flex;
  flex-direction: column;
  gap: 40px;
  padding-bottom: 40px;
`;

export const Section = styled('section')`
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

export const Entry = styled('div')`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const BulletList = styled('ul')`
  display: flex;
  flex-direction: column;
  gap: 6px;
  margin: 0;
  padding-left: 20px;
`;

export const BulletItem = styled('li')`
  margin: 0;
`;
